import { Configuration, MemberDetailsUpdate, MemberRecord, PublicApi } from 'clients/member-directory'
import { getBaseConfig } from './api/rest/config'

const getConfig = () => new Configuration({ baseOptions: getBaseConfig() })

const getPublicApi = (): PublicApi => new PublicApi(getConfig(), process.env.NEXT_PUBLIC_MEMBER_DIRECTORY_BASE)

export type MemberDetails = MemberRecord['details']

export const getMemberDetails = async (idToken: string): Promise<MemberDetails> => {
  const memberApi = getPublicApi()
  const headers = { Authorization: `Bearer ${idToken}` }
  const memberRecord = await memberApi.getMemberByUsername({ headers })
  return memberRecord.data.details
}

export const updateMemberDetails = async (memberData: MemberDetailsUpdate, idToken: string): Promise<MemberDetails> => {
  const memberApi = getPublicApi()
  const headers = { Authorization: `Bearer ${idToken}` }
  const updatedMemberRecord = await memberApi.updateMemberDetails(memberData, { headers })
  return updatedMemberRecord.data.details
}
